import {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Check, DollarSign, Plus, Save, User, X } from "react-feather";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { currencyContains } from "../../api/currencyApi";
import {
  chargeCreation,
  getAllChargesWithDeduction,
  getChargesByChhId,
  getExchangeSelectionValues,
  getJobInfo,
  getSuppNegoDetailsByJobId,
  getTemplateDetails,
  saveTemplate,
  updateCharges
} from "../../api/finance/addChargesApi";
import {
  getBulkDropdownData,
  getFieldValuesByTableAndId,
  getTextByValueAndKey,
} from "../../api/keyvalue";
import Grid from "../../components/Grid";
import InfoList from "../../components/InfoList";
import LoadingSpinner from "../../components/LoadingSpinner";
import Modal from "../../components/Modal";
import SuppNegoList from "../../components/finance/ChargeCreation/SuppNegoList";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import SelectRenderer from "../../components/renderer/SelectRenderer";
import { ResizableScrollingTextRenderer } from "../../components/renderer/StyleRenderer";
import { chargeTemplateCreationValidation } from "../../components/validations/ChargeCreation";
import { AUTH_TYPES, AUTHORITY_TYPE, FORMS, MODULES } from "../../const";
import { formatFromJsonDate } from "../../dateConfig";
import { isNumber } from "../../helper";
import useUserCompany from "../../hooks/useUserCompany";

const mode = {
  CREATE: 1,
  EDIT: 2,
};

const fieldPermissions = {
  CURRENCY: "currency",
  SAVE_TEMPLATE: "saveTemplate",
};

const HEADER_FORM = FORMS.CHARGE_CREATION.HEADER.form;
const DETAIL_FORM = FORMS.CHARGE_CREATION.DETAILS.form;

const AddCharges = ({
  jobInfo,
  template,
  editMode,
  handleDrawerClose,
  handleOpenEvinvDrawer,
  setUpdateNeeded,
  setUpdateTemplates,
  updateTemplates,
  isAdditional,
}) => {
  const user = useSelector((state) => state.user);
  const auth = useSelector((state) => state.user.permissions[MODULES.Finance]);
  const userCompany = useUserCompany();
  const userCurrency = userCompany ? userCompany.comCurrency : null;
  const userCurrencyCode = userCompany ? userCompany.comCurrencyCode : null;
  const userCurrencyName = userCompany ? userCompany.comCurrencyName : null;
  const chargeDetailPermissions = auth[DETAIL_FORM];
  const chargeHeaderPermissions = auth[HEADER_FORM];
  const approveEditPermission = chargeDetailPermissions?.FORM?.EDIT_APPROVED;
  const saveAsTemplatePermission =
    chargeDetailPermissions?.[fieldPermissions.SAVE_TEMPLATE]?.VIEW;
  const genEvPermission = chargeHeaderPermissions?.FORM?.GEN_EV;
  const genInvPermission = chargeHeaderPermissions?.FORM?.GEN_INV;
  const containsAnyGridPermissions = () => {
    console.log(chargeDetailPermissions);
    const gridPermissionKeys = chargeDetailPermissions
      ? Object.keys(chargeDetailPermissions).filter(
          (permission) =>
            permission !== "FORM" &&
            permission !== fieldPermissions.CURRENCY &&
            permission !== fieldPermissions.SAVE_TEMPLATE,
        )
      : [];
    console.log(gridPermissionKeys);
    return gridPermissionKeys.length > 0;
  };
  const [drawerTab, setDrawerTab] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isBlurred, setIsBlurred] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isJobInfoLoading, setIsJobInfoLoading] = useState(false);
  const [rowCount, setRowCount] = useState(2);
  const [templateDetailsLoading, setTemplateDetailsLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [chargeOpt, setChargeOpt] = useState("");
  const [revCostOpt, setRevCostOpt] = useState("");
  const [statusOpt, setStatusOpt] = useState("");
  const [activeOpt, setActiveOpt] = useState("");
  const [uomOpt, setUomOpt] = useState("");

  const [jobData, setJobData] = useState({});
  const [JobSummary, setJobSummary] = useState([]);
  const [isExistingJobChargesLoading, setIsExistingJobChargesLoading] =
    useState(false);
  const [currency, setCurrency] = useState(userCurrency);
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [chargeHeader, setChargeHeader] = useState({});
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [deletedList, setDeletedList] = useState([]);
  const [initialChdIdList, setInitialChdIdList] = useState([]);

  const gridRef = useRef(null);
  const [customerSupplierOpt, setCustomerSupplierOpt] = useState([]);
  const [savingTemplate, setSavingTemplate] = useState(false);
  const [category, setCategory] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [templateDescription, setTemplateDescription] = useState("");
  const [currentErrors, setCurrentErrors] = useState({});
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null,
  );
  const [exchangeRates, setExchangeRates] = useState([]);
  const modal2Ref = useRef();
  const [rowData, setRowData] = useState({});
  const [deletedCost, setDeletedCost] = useState(0);
  const [deletedRevenue, setDeletedRevenue] = useState(0);
  const [exchangeRate, setExchangeRate] = useState({});
  const [reqCode, setReqCode] = useState("");
  const [suppNegoList, setSuppNegoList] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(true);
  const [focRev, setFocRev] = useState(
    jobInfo?.jobFocRev ? jobInfo.jobFocRev : false,
  );
  const [focCost, setFocCost] = useState(
    jobInfo?.jobFocCost ? jobInfo.jobFocCost : false,
  );

  const closeModal2 = () => {
    modal2Ref.current.close();
  };

  const openModal2 = () => {
    modal2Ref.current?.showModal();
  };

  useEffect(() => {
    setCurrency(userCurrency);
  }, [userCurrency]);

  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  useEffect(() => {
    (async () => {
      if (!editMode) {
        setIsJobInfoLoading(true);

        const suppNego = await getSuppNegoDetailsByJobId(jobInfo.jobId);
        console.log("suppNego", suppNego);
        setSuppNegoList(suppNego);

        const response = await getJobInfo(jobInfo.jobId);
        const jobInfoData = response ? response[0] : {};

        setFocRev(
          jobInfoData?.jobFocRev ? jobInfoData.jobFocRev : jobInfo?.jobFocRev,
        );
        setFocCost(
          jobInfoData?.jobFocCost
            ? jobInfoData.jobFocCost
            : jobInfo?.jobFocCost,
        );
        setReqCode(jobInfoData?.reqCode ? jobInfoData.reqCode : "N/A");

        const jobInfoObject = [
          {
            title: "Job Code",
            value: jobInfoData?.jobCode ? jobInfoData.jobCode : "N/A",
          },
          {
            title: "Request Code",
            value: jobInfoData?.reqCode ? jobInfoData.reqCode : "N/A",
          },
          {
            title: "Customer",
            value: jobInfoData?.customerName ? jobInfoData.customerName : "N/A",
          },
          {
            title: "Currency",
            value: (
              <SearchDropdown
                key={1}
                authenticated={true}
                module={MODULES.Finance}
                form={DETAIL_FORM}
                field={fieldPermissions.CURRENCY}
                defaultValue={userCurrencyName}
                reset={searchFieldReset}
                setReset={setSearchFieldReset}
                onResultSelect={(data) => setCurrency(data)}
                api={currencyContains}
                fieldInfo={{
                  tableName: "masterdata.tms_vm_reg_currency",
                  primaryKey: "cur_id",
                  fieldName: "cur_currency",
                  id: currency,
                }}
                readOnly={true}
              />
            ),
          },
          {
            title: "Shipper",
            value: jobInfoData?.shipperName ? jobInfoData.shipperName : "N/A",
          },
          {
            title: "Billing Customer",
            value: jobInfoData?.billinCustomer
              ? jobInfoData.billinCustomer
              : "N/A",
          },
          {
            title: "Invoicing Customer",
            value: jobInfoData?.invoicingCustomer
              ? jobInfoData.invoicingCustomer
              : "N/A",
          },
          {
            title: "Vehicle No",
            value: jobInfoData?.vehVehicleno ? jobInfoData.vehVehicleno : "N/A",
          },
          {
            title: "Containers",
            value: jobInfoData?.conNumbers ? jobInfoData.conNumbers : "N/A",
          },
          {
            title: "Transporter",
            value: jobInfoData?.transporterName
              ? jobInfoData.transporterName
              : "N/A",
          },
          {
            title: "Actual Kms",
            value: jobInfoData?.chargeableValue
              ? jobInfoData.chargeableValue
              : "N/A",
          },
          {
            title: "Chargable Kms",
            value: jobInfoData?.chargeableKm ? jobInfoData.chargeableKm : "N/A",
          },
          {
            title: "Rate Type",
            value: jobInfoData?.rateType ? jobInfoData.rateType : "N/A",
          },
          {
            title: "VHT Type",
            value: jobInfoData?.vhtType ? jobInfoData.vhtType : "N/A",
          },
          // {
          //   title: "Negotiation",
          //   value: jobInfoData?.negotiation ? jobInfoData.negotiation : "N/A",
          // },
          {
            title: "Pickup Location",
            value: jobInfoData?.startLocation
              ? jobInfoData.startLocation
              : "N/A",
          },
          {
            title: "Delivery Location",
            value: jobInfoData?.endLocation ? jobInfoData.endLocation : "N/A",
          },
          {
            title: "Pickup Time",
            value: jobInfoData?.jobFirstArrivalTime
              ? formatFromJsonDate(jobInfoData.jobFirstArrivalTime)
              : "N/A",
          },
          {
            title: "Delivery Time",
            value: jobInfoData?.jobLastDepartureTime
              ? formatFromJsonDate(jobInfoData.jobLastDepartureTime)
              : "N/A",
          },
          {
            title: "Total Hours",
            value: jobInfoData?.jobTotalHours
              ? jobInfoData.jobTotalHours
              : "N/A",
          },
          {
            title: "Invoice No",
            value: jobInfoData?.fisInvoices ? jobInfoData.fisInvoices : "N/A",
          },
          {
            title: "Via Locations",
            value: jobInfoData?.viaLocations ? jobInfoData.viaLocations : "N/A",
          },
          {
            title: "Other Requests",
            value: jobInfoData?.otherRequests
              ? jobInfoData.otherRequests
              : "N/A",
          },
          {
            title: "Creator Remark",
            value: jobInfoData?.creatorRemark
              ? jobInfoData.creatorRemark
              : "N/A",
          },
          {
            title: "Operation Remark",
            value: jobInfoData?.operationRemark
              ? jobInfoData.operationRemark
              : "N/A",
          },
          {
            title: "Return Remark",
            value: jobInfoData?.jobReturnRemark
              ? jobInfoData.jobReturnRemark
              : "N/A",
          },
        ];

        setJobSummary(jobInfoObject);
        setJobData(jobInfoData);

        setIsJobInfoLoading(false);
      }
    })();
  }, [jobInfo, editMode]);

  useEffect(() => {
    (async () => {
      if (editMode) {
        setIsExistingJobChargesLoading(true);

        const charges = await getChargesByChhId(jobInfo?.chgId);
        console.log("Charges set", charges);
        setChargeHeader(charges.jobChargeHeader);

        const jobDetails = await getJobInfo(jobInfo.jobId);
        console.log("JobDetails", jobDetails);
        const jobInfoData = jobDetails ? jobDetails[0] : {};
        setFocRev(
          jobInfoData?.jobFocRev ? jobInfoData.jobFocRev : jobInfo?.jobFocRev,
        );
        setFocCost(
          jobInfoData?.jobFocCost
            ? jobInfoData.jobFocCost
            : jobInfo?.jobFocCost,
        );

        const suppNego = await getSuppNegoDetailsByJobId(jobInfo.jobId);
        console.log("suppNego", suppNego);
        setSuppNegoList(suppNego);

        setCurrency(charges.jobChargeHeader?.chhCurrency);

        const currencyDetails = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_vm_reg_currency",
          primaryKey: "cur_id",
          fieldNames: "cur_currency",
          ids: charges.jobChargeHeader.chhCurrency?.toString(),
        });
        const currencyName =
          currencyDetails && currencyDetails.length > 0
            ? currencyDetails[0].field1
            : "";

        const customer = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_stakeholder",
          primaryKey: "stk_id",
          fieldNames: "stk_name",
          ids: charges.jobChargeHeader.chhCustomer?.toString(),
        });
        const customerName =
          customer && customer.length > 0 ? customer[0].field1 : "";

        const transporter = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_stakeholder",
          primaryKey: "stk_id",
          fieldNames: "stk_name",
          ids: charges.jobChargeHeader.chhSupplier?.toString(),
        });
        const transporterName =
          transporter && transporter.length > 0 ? transporter[0].field1 : "";

        const EV = await getTextByValueAndKey(
          "ev_inv_status",
          charges.jobChargeHeader.chhEvStatus,
        );
        const INV = await getTextByValueAndKey(
          "ev_inv_status",
          charges.jobChargeHeader.chhInvStatus,
        );

        const status = await getTextByValueAndKey(
          "status",
          charges.jobChargeHeader.chhStatus,
        );

        const active = await getTextByValueAndKey(
          "active",
          charges.jobChargeHeader.chhActive,
        );

        const vehicle = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_vehicle_details",
          primaryKey: "veh_id",
          fieldNames: "veh_vehicleno",
          ids: charges.jobChargeHeader.chhVehicle?.toString(),
        });

        const vehicleName =
          vehicle && vehicle.length > 0 ? vehicle[0].field1 : "";

        const reqCodeData = await getFieldValuesByTableAndId({
          tableName: "transport.tms_t_request",
          primaryKey: "req_id",
          fieldNames: "req_code",
          ids: charges.jobChargeHeader.chhRequest?.toString(),
        });

        const reqCodeName =
          reqCodeData && reqCodeData.length > 0 ? reqCodeData[0].field1 : "";

        const formatToTwoDecimalPlaces = (value) => {
          if (value == null || value === "N/A") {
            return "N/A";
          }
          const num = parseFloat(value);
          const ceiledNum = isNaN(num) ? "N/A" : num.toFixed(2);
          const formatter = Intl.NumberFormat("en-US", {
            style: "currency",
            currency: userCurrencyCode,
          });

          return formatter.format(ceiledNum);
        };

        const summaryInfo = [
          {
            title: "Charge Code",
            value: charges.jobChargeHeader.chhCode
              ? charges.jobChargeHeader.chhCode
              : "N/A",
          },
          {
            title: "Request Code",
            value: reqCodeName ? reqCodeName : "N/A",
          },
          {
            title: "Customer",
            value: customerName ? customerName : "N/A",
          },
          {
            title: "Currency",
            value: (
              <SearchDropdown
                key={1}
                defaultValue={currencyName || "Sri Lanka Rupee"}
                authenticated={true}
                module={MODULES.Finance}
                form={HEADER_FORM}
                field={fieldPermissions.CURRENCY}
                reset={searchFieldReset}
                setReset={setSearchFieldReset}
                onResultSelect={(data) => setCurrency(data)}
                api={currencyContains}
                fieldInfo={{
                  tableName: "masterdata.tms_vm_reg_currency",
                  primaryKey: "cur_id",
                  fieldName: "cur_currency",
                  id: currency,
                }}
                readOnly={true}
              />
            ),
          },
          {
            title: "Cost",
            value: charges.jobChargeHeader.chhCost
              ? formatToTwoDecimalPlaces(charges.jobChargeHeader.chhCost)
              : "N/A",
          },
          {
            title: "EV Status",
            value: EV ? EV : "N/A",
          },
          {
            title: "Revenue",
            value: charges.jobChargeHeader.chhRevenue
              ? formatToTwoDecimalPlaces(charges.jobChargeHeader.chhRevenue)
              : "N/A",
          },
          {
            title: "Inv Status",
            value: INV ? INV : "N/A",
          },
          {
            title: "Vehicle No",
            value: vehicleName ? vehicleName : "N/A",
          },
          {
            title: "Containers",
            value: charges.jobChargeHeader.containerNumber
              ? charges.jobChargeHeader.containerNumber
              : "N/A",
          },
          {
            title: "Transporter",
            value: transporterName ? transporterName : "N/A",
          },
          {
            title: "Actual Kms",
            value: jobDetails[0]?.chargeableValue
              ? jobDetails[0].chargeableValue
              : "N/A",
          },
          {
            title: "Chargable Kms",
            value: jobDetails[0]?.chargeableKm
              ? jobDetails[0].chargeableKm
              : "N/A",
          },
          {
            title: "From Date",
            value: jobDetails[0]?.fromDate
              ? jobDetails[0].fromDate.split("T")[0]
              : "N/A",
          },
          {
            title: "Shipper",
            value: jobDetails[0]?.shipperName
              ? jobDetails[0].shipperName
              : "N/A",
          },
          {
            title: "Rate Type",
            value: jobDetails[0]?.rateType ? jobDetails[0].rateType : "N/A",
          },
          {
            title: "VHT Type",
            value: jobDetails[0]?.vhtType ? jobDetails[0].vhtType : "N/A",
          },
          {
            title: "To Date",
            value: jobDetails[0]?.toDate
              ? jobDetails[0].toDate.split("T")[0]
              : "N/A",
          },
          {
            title: "Pickup Location",
            value: jobDetails[0]?.startLocation
              ? jobDetails[0].startLocation
              : "N/A",
          },
          {
            title: "Delivery Location",
            value: jobDetails[0]?.endLocation
              ? jobDetails[0].endLocation
              : "N/A",
          },
          {
            title: "Pickup Time",
            value: jobDetails[0]?.jobFirstArrivalTime
              ? formatFromJsonDate(jobDetails[0].jobFirstArrivalTime)
              : "N/A",
          },
          {
            title: "Delivery Time",
            value: jobDetails[0]?.jobLastDepartureTime
              ? formatFromJsonDate(jobDetails[0].jobLastDepartureTime)
              : "N/A",
          },
          {
            title: "Total Hours",
            value: jobDetails[0]?.jobTotalHours
              ? jobDetails[0].jobTotalHours
              : "N/A",
          },
          {
            title: "Invoice No",
            value: jobDetails[0]?.fisInvoices
              ? jobDetails[0].fisInvoices
              : "N/A",
          },
          {
            title: "EV No",
            value: jobDetails[0]?.fisEvs ? jobDetails[0].fisEvs : "N/A",
          },
          {
            title: "Active",
            value: active ? active : "N/A",
          },
          {
            title: "Status",
            value: status ? status : "N/A",
          },
          {
            title: "Via Locations",
            value: jobDetails[0]?.viaLocations
              ? jobDetails[0].viaLocations
              : "N/A",
          },
          {
            title: "Other Requests",
            value: jobDetails[0]?.otherRequests
              ? jobDetails[0].otherRequests
              : "N/A",
          },
          {
            title: "Creator Remark",
            value: jobDetails[0]?.creatorRemark
              ? jobDetails[0].creatorRemark
              : "N/A",
          },
          {
            title: "Operation Remark",
            value: jobDetails[0]?.operationRemark
              ? jobDetails[0].operationRemark
              : "N/A",
          },
          {
            title: "Rate Ids",
            value: charges.jobChargeHeader.chhRateIds
              ? charges.jobChargeHeader.chhRateIds
              : "N/A",
          },
          {
            title: "Return Remarks",
            value: jobDetails?.jobReturnRemark
              ? jobDetails.jobReturnRemark
              : "N/A",
          },
        ];
        setJobSummary(summaryInfo);

        let chdIdList = [];
        let currentCharges = [];
        let id = 2;
        for (let currentCharge of charges.jobChargeDetails) {
          currentCharges.push({
            id: id++,
            chdId: currentCharge.chdId,
            chdCompany: currentCharge.chdCompany,
            chdCharge: currentCharge.chdChargeId,
            chdReqCode: currentCharge.chdReqCode
              ? currentCharge.chdReqCode
              : reqCode,
            chdChacrges: currentCharge.chdChacrges,
            chdDescription: currentCharge.chdDescription,
            chdCurrency: currentCharge.chdCurrency,
            chdExcId: currentCharge.chdExcId ? currentCharge.chdExcId : -1,
            chdExcRate: currentCharge.chdExcRate ? currentCharge.chdExcRate : 1,
            chdExcCurrency: {
              excId: currentCharge.chdExcId ? currentCharge.chdExcId : -1,
              excRate: currentCharge.chdExcRate ? currentCharge.chdExcRate : 1,
              curCode: currentCharge.chdCurCode,
            },
            chdValue: currentCharge.chdValue,
            chdQty: currentCharge.chdQty,
            chdTotal: currentCharge.chdTotal,
            chdSavedTotal: currentCharge.chdTotal,
            chdUom: currentCharge.chdUom,
            chdStatus: currentCharge.chdStatus,
            chdActive: currentCharge.chdActive,
            chdChargeType: currentCharge.chdChargeType,
            chdRahId: currentCharge.chdRahId,
            chdCreatedType: currentCharge.chdCreatedType,
            chdModifiedType: currentCharge.chdModifiedType,
            chtDeduct: currentCharge.chtDeduct,
            systemGenerated: currentCharge.chdDescription
              ? currentCharge.chdDescription.includes("[TMS_GENERATED]")
              : false,
            persisted: true,
          });

          chdIdList.push(currentCharge.chdId);
        }
        setRowCount(id);

        setInitialChdIdList(chdIdList);
        setGridData(currentCharges);

        setIsExistingJobChargesLoading(false);
        console.log("charges", charges);
      }
    })();
  }, [jobInfo, editMode]);

  console.log("grid data", gridData);

  const handleSelectionChanged = useCallback(() => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const exchangeSelection = await getExchangeSelectionValues({
        baseCurrency: currency,
        headerId: editMode ? jobInfo?.jobChargeHeader?.chhId : -1,
        currency: null,
        bank: null,
        branch: null,
        user: user.username,
        company: company,
      });
      console.log("exchangeSelection", exchangeSelection);
      setExchangeRates(exchangeSelection);

      // const charges = await getAllCharges();
      // setChargeOpt(charges);

      const charges = await getAllChargesWithDeduction();
      setChargeOpt(charges);

      const {
        status,
        active,
        revcost: revCost,
        uom,
        rate_type_for: rateTypes,
      } = await getBulkDropdownData([
        { key: "status" },
        { key: "active" },
        {
          key: "revcost",
          authenticated: true,
          authorities: [
            "CHARGE_CREATION_FORM_ADD_REVENUE",
            "CHARGE_CREATION_FORM_ADD_COST",
          ],
        },
        { key: "uom" },
        { key: "rate_type_for" },
      ]);
      if (focRev && focCost) {
        setRevCostOpt([]);
      } else if (focCost) {
        const focCostOption = revCost?.filter((option) => option.key !== 2);
        setRevCostOpt(focCostOption);
      } else if (focRev) {
        const focRevOption = revCost?.filter((option) => option.key !== 1);
        setRevCostOpt(focRevOption);
      } else {
        setRevCostOpt(revCost);
      }
      setUomOpt(uom);
      setStatusOpt(status);
      setActiveOpt(active);
      setCustomerSupplierOpt(rateTypes);
      setIsLoading(false);
    })();
  }, [currency, editMode, jobInfo, user, company, focRev, focCost]);
  console.log("chargeOptions", chargeOpt);

  console.log("jobInfo", jobInfo);
  useEffect(() => {
    if (!editMode) {
      (async () => {
        setTemplateDetailsLoading(true);
        const parsedValue =
          exchangeRates.length > 0 ? JSON.parse(exchangeRates[0]?.value) : null;
        console.log("parsedValue", parsedValue);

        const response = await getJobInfo(jobInfo.jobId);
        const jobInfoData = response ? response[0] : {};

        const templateData = await getTemplateDetails(template);
        console.log("templateData", templateData);

        if (templateData?.length > 0) {
          const data = templateData?.map((item, index) => {
            return {
              id: index,
              chdReqCode: jobInfoData?.reqCode ? jobInfoData.reqCode : "N/A",
              chdChacrges: item.incCharge,
              chdDescription: "",
              chdExcCurrency: exchangeRates[0]?.key === -1 ? parsedValue : {},
              chdExcId: exchangeRates[0]?.key === -1 ? parsedValue.excId : null,
              chdExcRate:
                exchangeRates[0]?.key === -1 ? parsedValue.excRate : null,
              chdValue: 0,
              chdQty: 1,
              chdTotal: 0,
              chdSavedTotal: 0,
              chdUom: 1,
              chdStatus: 2,
              chdActive: 1,
              chdChargeType: item.incChgType,
              chtDeduct: item.chtDeduct,
              mode: mode.CREATE,
            };
          });
          setGridData(data);
          setRowCount(data.length);
        } else {
          setGridData([]);
          setRowCount(2);
        }
        setTemplateDetailsLoading(false);
      })();
    }
  }, [template, exchangeRates, editMode]);

  const handleAddRow = () => {
    const parsedValue =
      exchangeRates.length > 0 ? JSON.parse(exchangeRates[0]?.value) : null;
    let currentRowCount = rowCount + 1;
    const newRow = {
      id: currentRowCount,
      chdReqCode: reqCode,
      chdCompany: company,
      chdCurrency: currency,
      chdChacrges: null,
      chdDescription: "",
      chdExcCurrency: exchangeRates[0]?.key === -1 ? parsedValue : {},
      chdExcId: exchangeRates[0]?.key === -1 ? parsedValue.excId : null,
      chdExcRate: exchangeRates[0]?.key === -1 ? parsedValue.excRate : null,
      chdValue: 0,
      chdQty: 1,
      chdTotal: 0,
      chdSavedTotal: 0,
      chdUom: 1,
      chdStatus: 2,
      chdActive: 1,
      chdChargeType: null,
      chdCreatedType: 1,
      chdModifiedType: 1,
      chtDeduct: 2,
      mode: mode.CREATE,
    };

    setGridData([...gridData, newRow]);
    setRowCount(currentRowCount);
  };

  const cellEditorParams = (params) => {
    console.log("params in cell editor", params);
    if (params.valueChanged) {
      if (
        parseInt(params.data.chdChargeType) === 2 &&
        chargeHeader?.chhEvStatus === 3
      ) {
        setChargeHeader((prevState) => ({
          ...prevState,
          evModified: true,
        }));
      } else if (
        parseInt(params.data.chdChargeType) === 1 &&
        chargeHeader?.chhInvStatus === 3
      ) {
        setChargeHeader((prevState) => ({
          ...prevState,
          invModified: true,
        }));
      }
    }

    switch (params.colDef.field) {
      case "chdValue": {
        console.log("params.coldef", params.colDef.field);
        let rowValue = Math.abs(Number(params.value));
        let value = params.data.chtDeduct === 2 ? rowValue : -rowValue;
        console.log("params.data", params.data);
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              if (row.persisted) {
                return {
                  ...row,
                  chdValue: value,
                  chdTotal: params.data.chdQty * value * params.data.chdExcRate,
                  mode: mode.EDIT,
                };
              } else {
                return {
                  ...row,
                  chdValue: value,
                  chdTotal: params.data.chdQty * value * params.data.chdExcRate,
                };
              }
            }
            return row;
          }),
        );
        break;
      }
      case "chdQty": {
        let value = Math.abs(Number(params.value));
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              if (row.persisted) {
                return {
                  ...row,
                  chdQty: value,
                  chdTotal:
                    params.data.chdValue * value * params.data.chdExcRate,
                  mode: mode.EDIT,
                };
              } else {
                return {
                  ...row,
                  chdQty: value,
                  chdTotal:
                    params.data.chdValue * value * params.data.chdExcRate,
                };
              }
            }
            return row;
          }),
        );
        break;
      }
      case "chdDescription": {
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              if (row.persisted) {
                return {
                  ...row,
                  chdDescription: params.value,
                  mode: mode.EDIT,
                };
              } else {
                return {
                  ...row,
                  chdDescription: params.value,
                };
              }
            }
            return row;
          }),
        );
        break;
      }

      default:
    }
  };

  const resetForm = () => {
    setGridData([]);
    setSelectedRows([]);
    setRowCount(2);
  };

  const chargeValidator = () => {
    let isValid = true;
    for (let row of selectedRows) {
      if (row.chdChacrges === null) {
        isValid = false;
        break;
      }
      if (row.chdChargeType === null) {
        isValid = false;
        break;
      }
      // if (row.chdDescription === "") {
      //   isValid = false;
      //   break;
      // }
      if (row.chdExcId === null) {
        isValid = false;
        break;
      }
      if (row.chdValue === null) {
        isValid = false;
        break;
      }
      // if (row.chdQty === null) {
      //   isValid = false;
      //   console.log("chdQty");
      //   break;
      // }
      // if (row.chdUom === "") {
      //   isValid = false;
      //   console.log("chdUom");
      //   break;
      // }
      // if (row.chdStatus === "") {
      //   isValid = false;
      //   console.log("chdStatus");
      //   break;
      // }
      // if (row.chdActive === "") {
      //   isValid = false;
      //   console.log("chdActive");
      //   break;
      // }
    }
    return isValid;
  };

  const qtyAndValueValidator = () => {
    let isValid = true;
    for (let row of selectedRows) {
      if (row.chdValue < 0) {
        isValid = false;
        break;
      }
      if (row.chdQty <= 0) {
        isValid = false;
        break;
      }
    }
    return isValid;
  };

  const addCharge = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    setIsBlurred(true);
    try {
      if (selectedRows?.length === 0) {
        toast.error("Please add charges", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        setIsBlurred(false);
        return;
      }

      if (!chargeValidator()) {
        toast.error("Please fill all the fields in the grid", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsSubmitLoading(false);
        setIsBlurred(false);
        return;
      }

      // if (!qtyAndValueValidator()) {
      //   toast.error("Qty and Value should be greater than 0", {
      //     autoClose: 5000,
      //     containerId: "Main",
      //   });
      //   setIsSubmitLoading(false);
      //   setIsBlurred(false);
      //   return;
      // }

      const response = await chargeCreation({
        jobChargeHeader: {
          chhCompany: company,
          chhRequest: jobData.jobRequest,
          chhJobId: jobData.jobId,
          chhCustomer: jobData.customerId,
          chhSupplier: jobData.transId,
          chhVehicle: jobData.jobVehicle,
          chhKm: jobData.chargeableValue,
          chhRevenue: selectedRows?.reduce((acc, item) => {
            if (item.chdStatus === 2) {
              if (parseInt(item.chdChargeType) === 1) {
                return acc + item.chdTotal;
              }
            }
            return acc;
          }, 0),
          chhCost: selectedRows?.reduce((acc, item) => {
            if (item.chdStatus === 2) {
              if (parseInt(item.chdChargeType) === 2) {
                return acc + item.chdTotal;
              }
            }
            return acc;
          }, 0),
          chhCurrency: currency,
          chhExchangeRate: null,
          chhDescription1: "",
          chhDescription2: "",
          chhFormDate: jobData.fromDate,
          chhToDate: jobData.toDate,
          chhEvStatus: 1,
          chhInvStatus: 1,
          chhStatus: 2,
          chhActive: 1,
          chhAdditional: isAdditional,
        },
        jobChargeDetails: selectedRows?.map((item) => ({
          chdCompany: company,
          chdChargeType: item.chdChargeType,
          chdChacrges: item.chdChacrges,
          chdValue:
            item.chtDeduct === 1 && item.chdValue > 0
              ? -item.chdValue
              : item.chtDeduct === 2 && item.chdValue < 0
                ? -item.chdValue
                : item.chdValue,
          chdCurrency: currency,
          chdQty: item.chdQty,
          chdDescription: item.chdDescription,
          chdExcId: item.chdExcId,
          chdExcRate: item.chdExcRate,
          chdUom: item.chdUom,
          chdTotal:
            item.chtDeduct === 1 && item.chdTotal > 0
              ? -item.chdTotal
              : item.chtDeduct === 2 && item.chdTotal < 0
                ? -item.chdTotal
                : item.chdTotal,
          chdStatus: item.chdStatus,
          chdActive: item.chdActive,
          chdCreatedType: item.chdCreatedType,
          chdModifiedType: item.chdModifiedType,
        })),
        author: user.username,
      });
      console.log("creation response", response);
      if (response.status === 201) {
        toast.success(response.data + " !", {
          autoClose: 5000,
          containerId: "Main",
        });
        resetForm();
        handleDrawerClose();
        setUpdateNeeded(true);
      } else {
        toast.error(response.data, { autoClose: 5000, containerId: "Main" });
      }
    } catch (e) {
      if (e?.response?.data) {
        toast.error(e?.response?.data, {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        toast.error("Something went wrong", {
          autoClose: 5000,
          containerId: "Main",
        });
      }
    } finally {
      setIsSubmitLoading(false);
      setIsBlurred(false);
    }
  };

  const areListsEqual = (list1, list2) => {
    if (list1.length !== list2.length) return false;

    const sorted1 = [...list1].sort();
    const sorted2 = [...list2].sort();

    return sorted1.every((value, index) => value === sorted2[index]); //
  };

  const updateCharge = async (e) => {
    e.preventDefault();
    setIsUpdateLoading(true);
    setIsBlurred(true);

    const updateState = getUpdateState();

    if (
      updateState.created?.length === 0 &&
      areListsEqual(updateState.deleted, initialChdIdList)
    ) {
      toast.warn("At least one charge should be available", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsUpdateLoading(false);
      setIsBlurred(false);
      return;
    }

    if (
      updateState.created.length !== 0 &&
      updateState.modified.length !== 0 &&
      updateState.deleted.length === 0
    ) {
      if (selectedRows?.length === 0) {
        toast.error("Please select charges", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsUpdateLoading(false);
        setIsBlurred(false);
        return;
      }
    }

    if (!chargeValidator()) {
      toast.error("Please fill all the fields in grid", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsUpdateLoading(false);
      setIsBlurred(false);
      return;
    }

    // if (!qtyAndValueValidator()) {
    //   toast.error("Value and Qty should be greater than 0", {
    //     autoClose: 5000,
    //     containerId: "Main",
    //   });
    //   setIsUpdateLoading(false);
    //   setIsBlurred(false);
    //   return;
    // }

    let existingTotalCost = 0;
    let existingTotalRevenue = 0;
    let newTotalCost = 0;
    let newTotalRevenue = 0;

    for (let charge of selectedRows) {
      if (parseInt(charge.chdChargeType) === 1) {
        if (charge.chdStatus === 2) {
          if (charge.chdSavedTotal !== charge.chdTotal) {
            newTotalRevenue += charge.chdTotal - charge.chdSavedTotal;
          }
        }
      } else {
        if (charge.chdStatus === 2) {
          console.log("saved total", charge.chdSavedTotal);
          console.log("chd total", charge.chdTotal);
          if (charge.chdSavedTotal !== charge.chdTotal) {
            newTotalCost += charge.chdTotal - charge.chdSavedTotal;
            console.log("New total cost", newTotalCost);
          }
        }
      }
    }

    const totalCost = existingTotalCost + newTotalCost;
    const totalRevenue = existingTotalRevenue + newTotalRevenue;

    try {
      const response = await updateCharges({
        jobChargeHeaderRequest: {
          ...chargeHeader,
          chhCompany: company,
          chhRevenue: chargeHeader.chhRevenue + totalRevenue - deletedRevenue,
          chhCost: chargeHeader.chhCost + totalCost - deletedCost,
          chhCurrency: currency,
        },
        jobChargeDetailsRequest: updateState,
        author: user.username,
      });

      if (response.status === 200) {
        toast.success(response.data + " !", {
          autoClose: 5000,
          containerId: "Main",
        });
        resetForm();
        handleDrawerClose();
        setUpdateNeeded(true);
      } else {
        toast.error(response.data, { autoClose: 5000, containerId: "Main" });
      }
    } catch (e) {
      if (e?.response?.data) {
        toast.error(e?.response?.data, {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        toast.error("Something went wrong", {
          autoClose: 5000,
          containerId: "Main",
        });
      }
    } finally {
      setIsUpdateLoading(false);
      setIsBlurred(false);
    }
  };

  const getUpdateState = () => {
    const updateState = {
      created: [],
      modified: [],
      deleted: deletedList,
    };

    for (let r of selectedRows) {
      if (r.mode === mode.CREATE) {
        updateState.created.push({
          ...r,
          chdValue:
            r.chtDeduct === 1 && r.chdValue > 0
              ? -r.chdValue
              : r.chtDeduct === 2 && r.chdValue < 0
                ? -r.chdValue
                : r.chdValue,
          chdTotal:
            r.chtDeduct === 1 && r.chdTotal > 0
              ? -r.chdTotal
              : r.chtDeduct === 2 && r.chdTotal < 0
                ? -r.chdTotal
                : r.chdTotal,
        });
      }
      if (r.mode === mode.EDIT) {
        updateState.modified.push({
          ...r,
          chdModifiedType: 1,
          chdValue:
            r.chtDeduct === 1 && r.chdValue > 0
              ? -r.chdValue
              : r.chtDeduct === 2 && r.chdValue < 0
                ? -r.chdValue
                : r.chdValue,
          chdTotal:
            r.chtDeduct === 1 && r.chdTotal > 0
              ? -r.chdTotal
              : r.chtDeduct === 2 && r.chdTotal < 0
                ? -r.chdTotal
                : r.chdTotal,
        });
      }
    }

    return updateState;
  };

  const modalRef = useRef();
  const openModal = () => {
    modalRef.current?.showModal();
  };

  const closeModal = () => {
    modalRef.current.close();
  };

  const saveAsTemplate = async (e) => {
    e.preventDefault();
    setSavingTemplate(true);

    const templateErrors = chargeTemplateCreationValidation({
      intTemplateName: templateName,
      intCategory: category,
    });

    if (Object.keys(templateErrors).length > 0) {
      setCurrentErrors(templateErrors);
      document.querySelector(".ui.form").classList.add("error");
      toast.error("please Fill the required fields", {
        autoClose: 5000,
        containerId: "Main",
      });
      setSavingTemplate(false);
      return;
    } else {
      setCurrentErrors({});
      document.querySelector(".ui.form").classList.remove("error");

      for (let row of selectedRows) {
        if (row.chdChacrges === "") {
          toast.error("Please select charges for all rows", {
            autoClose: 5000,
            containerId: "Main",
          });
          setSavingTemplate(false);
          return;
        }
      }

      const response = await saveTemplate({
        chargeTemplateRequest: {
          intTemplateName: templateName,
          intCategory: category,
          intDescription: templateDescription,
          intStatus: 2,
          intActive: 1,
          intStakeholder: null,
          intCompany: company,
        },
        templateChargesRequests: selectedRows?.map((item, index) => ({
          incCharge: item.chdChacrges,
          incDescription: item.chdDescription,
          incStatus: 2,
          incActive: 1,
          incSeq: index + 1,
          incChgType: item.chdChargeType,
        })),
        author: user.username,
      });

      if (response.status === 201) {
        toast.success(response.data + " !", {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        toast.error(response.data, { autoClose: 5000, containerId: "Main" });
      }
    }

    setUpdateTemplates(!updateTemplates);
    closeModal();
    setSavingTemplate(false);
  };

  console.log("GridData", gridData);

  const isDisabled = (params) =>
    (((!approveEditPermission && chargeHeader.chhEvStatus === 3) ||
      chargeHeader.chhEvStatus === 2 ||
      chargeHeader.chhEvStatus === 5) &&
      params.data.chdChargeType === 2) ||
    (((!approveEditPermission && chargeHeader.chhInvStatus === 3) ||
      chargeHeader.chhInvStatus === 2 ||
      chargeHeader.chhInvStatus === 5) &&
      params.data.chdChargeType === 1) ||
    params.data.systemGenerated;

  const isValueDisabled = (params) => (!params.data.chdChacrges ? true : false);

  const getConfig = () => {
    const configData = [
      {
        headerName: "Request",
        field: "chdReqCode",
        cellEditor: "agTextCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        editable: false,
        cellRenderer: ResizableScrollingTextRenderer,
        width: "150",
        minWidth: "150",
      },
      {
        headerName: "Charge",
        field: "chdChacrges",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => ({
          onChangeHandler: (data) => {
            console.log("data", data);
            if (params.data.chdChargeType) {
              if (
                parseInt(params.data.chdChargeType) === 2 &&
                chargeHeader?.chhEvStatus === 3
              ) {
                setChargeHeader((prevState) => ({
                  ...prevState,
                  evModified: true,
                }));
              } else if (
                parseInt(params.data.chdChargeType) === 1 &&
                chargeHeader?.chhInvStatus === 3
              ) {
                setChargeHeader((prevState) => ({
                  ...prevState,
                  invModified: true,
                }));
              }
            }

            const deduct = chargeOpt?.find((item) => item.id === data);
            console.log("deduct", deduct);

            const value =
              deduct?.description === 1 && params.data.chdValue > 0
                ? -params.data.chdValue
                : deduct?.description === 2 && params.data.chdValue < 0
                  ? -params.data.chdValue
                  : params.data.chdValue;

            setGridData((prev) =>
              prev.map((item) => {
                if (item.id === params.data.id) {
                  if (item.persisted) {
                    return {
                      ...item,
                      chdChacrges: data,
                      chtDeduct: deduct?.description ? deduct.description : 2,
                      chdValue: value,
                      chdTotal:
                        params.data.chdQty * value * params.data.chdExcRate,
                      mode: mode.EDIT,
                    };
                  } else {
                    return {
                      ...item,
                      chdChacrges: data,
                      chtDeduct: deduct?.description ? deduct.description : 2,
                      chdValue: value,
                      chdTotal:
                        params.data.chdQty * value * params.data.chdExcRate,
                    };
                  }
                }
                return item;
              }),
            );
          },
          options: chargeOpt?.filter(opt => opt.activeStatus === 1 || opt.id === params.data.chdChacrges),
          placeholder: "Select Charge",
          module: MODULES.Finance,
          form: DETAIL_FORM,
          field: "chdChacrges",
          authenticated: true,
          value: params.data.chdChacrges,
          disabled: isDisabled(params),
          searchable: true,
        }),
      },
      {
        headerName: "Charge Type",
        field: "chdChargeType",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => {
          return {
            module: MODULES.Finance,
            form: DETAIL_FORM,
            field: "chdChargeType",
            authenticated: true,
            onChangeHandler: (data) => {
              if (params.data.chdChargeType) {
                console.log("CHARGE TYPE -> ", params);
                console.log(
                  "CHARGE TYPE HEADER-> ",
                  chargeHeader?.chhInvStatus,
                );
                if (
                  parseInt(params.data.chdChargeType) === 2 &&
                  chargeHeader?.chhEvStatus === 3
                ) {
                  setChargeHeader((prevState) => ({
                    ...prevState,
                    evModified: true,
                  }));
                } else if (
                  parseInt(params.data.chdChargeType) === 1 &&
                  chargeHeader?.chhInvStatus === 3
                ) {
                  setChargeHeader((prevState) => ({
                    ...prevState,
                    invModified: true,
                  }));
                }
              }
              setGridData((prev) =>
                prev.map((item) => {
                  if (item.id === params.data.id) {
                    if (item.persisted) {
                      if (
                        data === 2 &&
                        ((!approveEditPermission &&
                          chargeHeader?.chhEvStatus === 3) ||
                          chargeHeader?.chhEvStatus === 2 ||
                          chargeHeader?.chhEvStatus === 5)
                      ) {
                        toast.error(
                          "Cannot select cost type charge for EV Status Approved",
                          { autoClose: 5000, containerId: "Main" },
                        );
                      } else if (
                        data === 1 &&
                        ((!approveEditPermission &&
                          chargeHeader?.chhInvStatus === 3) ||
                          chargeHeader?.chhInvStatus === 2 ||
                          chargeHeader?.chhInvStatus === 5)
                      ) {
                        toast.error(
                          "Cannot select revenue type charge for INV Status Approved",
                          { autoClose: 5000, containerId: "Main" },
                        );
                      } else {
                        return {
                          ...item,
                          chdChargeType: data,
                          mode: mode.EDIT,
                        };
                      }
                    } else {
                      if (
                        data === 2 &&
                        ((!approveEditPermission &&
                          chargeHeader?.chhEvStatus === 3) ||
                          chargeHeader?.chhEvStatus === 2 ||
                          chargeHeader?.chhEvStatus === 5)
                      ) {
                        toast.error(
                          "Cannot select cost type charge for EV Status Approved",
                          { autoClose: 5000, containerId: "Main" },
                        );
                      } else if (
                        data === 1 &&
                        ((!approveEditPermission &&
                          chargeHeader?.chhInvStatus === 3) ||
                          chargeHeader?.chhInvStatus === 2 ||
                          chargeHeader?.chhInvStatus === 5)
                      ) {
                        toast.error(
                          "Cannot select revenue type charge for INV Status Approved",
                          { autoClose: 5000, containerId: "Main" },
                        );
                      } else {
                        return {
                          ...item,
                          chdChargeType: data,
                        };
                      }
                    }
                  }
                  return item;
                }),
              );
            },
            options: revCostOpt,
            placeholder: "Select Charge Type",
            value: params.data.chdChargeType,
            disabled: isDisabled(params),
            searchable: true,
          };
        },
      },
      {
        headerName: "Description",
        field: "chdDescription",
        cellEditor: "agTextCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellEditorParams: {
          maxLength: 100,
        },
        tooltipValueGetter: (params) => {
          return "press Enter to set the value";
        },
        editable: (params) => {
          return !isDisabled(params);
        },
        cellRenderer: ResizableScrollingTextRenderer,
        minWidth: 300,
      },
      {
        headerName: "Currency",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        field: "chdExcCurrency.curCode",
        cellRenderer: ResizableScrollingTextRenderer,
        tooltipValueGetter: (params) => {
          return "Double click to set the currency";
        },
        disabled: (params) => {
          return isDisabled(params);
        },
      },
      {
        headerName: "Value",
        field: "chdValue",
        cellEditor: "agNumberCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        editable: (params) => {
          return !isDisabled(params) && !isValueDisabled(params);
        },
        tooltipValueGetter: (params) => {
          if (params.data.chdChacrges === null) return "Select charge first";
          else return "press Enter to set the value";
        },
        valueFormatter: (params) => {
          const value = params.value || 0;
          return value.toFixed(2); // Always display with 2 decimal places
        },
      },
      {
        headerName: "Qty",
        field: "chdQty",
        cellEditor: "agNumberCellEditor",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        tooltipValueGetter: (params) => {
          return "press Enter to set the value";
        },
        editable: (params) => {
          return !isDisabled(params);
        },
        // valueFormatter: (params) => {
        //   const value = params.value || 1; //
        //   return value.toFixed(2); // Always display with 2 decimal places
        // },
      },
      {
        headerName: "Total",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        field: "chdTotal",
        valueFormatter: (params) => {
          const value = params.value || 0;
          return value.toFixed(2); // Always display with 2 decimal places
        },
      },
      {
        headerName: "UOM",
        field: "chdUom",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => ({
          onChangeHandler: (data) => {
            if (params.data.chdChargeType) {
              if (
                parseInt(params.data.chdChargeType) === 2 &&
                chargeHeader?.chhEvStatus === 3
              ) {
                setChargeHeader((prevState) => ({
                  ...prevState,
                  evModified: true,
                }));
              } else if (
                parseInt(params.data.chdChargeType) === 1 &&
                chargeHeader?.chhInvStatus === 3
              ) {
                setChargeHeader((prevState) => ({
                  ...prevState,
                  invModified: true,
                }));
              }
            }
            setGridData((prev) =>
              prev.map((item) => {
                if (item.id === params.data.id) {
                  if (item.persisted) {
                    return {
                      ...item,
                      chdUom: data,
                      mode: mode.EDIT,
                    };
                  } else {
                    return {
                      ...item,
                      chdUom: data,
                    };
                  }
                }
                return item;
              }),
            );
          },
          options: uomOpt,
          placeholder: "Select UOM",
          module: MODULES.Finance,
          form: DETAIL_FORM,
          field: "chdUom",
          authenticated: true,
          value: params.data.chdUom,
          disabled: isDisabled(params),
        }),
      },
      {
        headerName: "Status",
        field: "chdStatus",
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRenderer: SelectRenderer,
        cellRendererParams: (params) => ({
          onChangeHandler: (data) => {
            if (params.data.chdChargeType) {
              if (
                parseInt(params.data.chdChargeType) === 2 &&
                chargeHeader?.chhEvStatus === 3
              ) {
                setChargeHeader((prevState) => ({
                  ...prevState,
                  evModified: true,
                }));
              } else if (
                parseInt(params.data.chdChargeType) === 1 &&
                chargeHeader?.chhInvStatus === 3
              ) {
                setChargeHeader((prevState) => ({
                  ...prevState,
                  invModified: true,
                }));
              }
            }
            setGridData((prev) =>
              prev.map((item) => {
                if (item.id === params.data.id) {
                  if (item.persisted) {
                    return {
                      ...item,
                      chdStatus: data,
                      mode: mode.EDIT,
                    };
                  } else {
                    return {
                      ...item,
                      chdStatus: data,
                    };
                  }
                }
                return item;
              }),
            );
          },
          options: statusOpt,
          placeholder: "Select Status",
          module: MODULES.Finance,
          form: DETAIL_FORM,
          field: "chdStatus",
          authenticated: true,
          value: params.data.chdStatus,
          disabled: isDisabled(params),
        }),
      },
      // {
      //   headerName: "Active",
      //   field: "chdActive",
      //   module: MODULES.Finance,
      //   primaryForm: DETAIL_FORM,
      //   authenticated: true,
      //   cellRenderer: SelectRenderer,
      //   cellRendererParams: (params) => ({
      //     onChangeHandler: (data) => {
      //       if (params.data.chdChargeType) {
      //         if (
      //           parseInt(params.data.chdChargeType) === 2 &&
      //           chargeHeader?.chhEvStatus === 3
      //         ) {
      //           setChargeHeader((prevState) => ({
      //             ...prevState,
      //             evModified: true,
      //           }));
      //         } else if (
      //           parseInt(params.data.chdChargeType) === 1 &&
      //           chargeHeader?.chhInvStatus === 3
      //         ) {
      //           setChargeHeader((prevState) => ({
      //             ...prevState,
      //             invModified: true,
      //           }));
      //         }
      //       }
      //       setGridData((prev) =>
      //         prev.map((item) => {
      //           if (item.id === params.data.id) {
      //             if (item.persisted) {
      //               return {
      //                 ...item,
      //                 chdActive: data,
      //                 mode: mode.EDIT,
      //               };
      //             } else {
      //               return {
      //                 ...item,
      //                 chdActive: data,
      //               };
      //             }
      //           }
      //           return item;
      //         })
      //       );
      //     },
      //     options: activeOpt,
      //     placeholder: "Select Active",
      //     module: MODULES.Finance,
      //     form: DETAIL_FORM,
      //     field: "chdActive",
      //     authenticated: true,
      //     value: params.data.chdActive,
      //     disabled: isDisabled(params),
      //   }),
      // },
      {
        field: "chdDelete",
        cellRenderer: ButtonRenderer,
        module: MODULES.Finance,
        primaryForm: DETAIL_FORM,
        authenticated: true,
        cellRendererParams: (params) => {
          console.log(params);
          return {
            clickHandler: () => {
              if (params.data.persisted) {
                if (parseInt(params.data.chdChargeType) === 1) {
                  setDeletedRevenue((prev) => prev + params.data.chdTotal);
                } else {
                  setDeletedCost((prev) => prev + params.data.chdTotal);
                }

                if (params.data.chdChargeType) {
                  if (
                    parseInt(params.data.chdChargeType) === 2 &&
                    chargeHeader?.chhEvStatus === 3
                  ) {
                    setChargeHeader((prevState) => ({
                      ...prevState,
                      evModified: true,
                    }));
                  } else if (
                    parseInt(params.data.chdChargeType) === 1 &&
                    chargeHeader?.chhInvStatus === 3
                  ) {
                    setChargeHeader((prevState) => ({
                      ...prevState,
                      invModified: true,
                    }));
                  }
                }
                setDeletedList((prev) => [...prev, params.data.chdId]);
              }
              setGridData((prev) =>
                prev.filter((item) => item.id !== params.data.id),
              );
              setRowCount((prev) => prev - 1);
            },
            label: "Delete",
            className: "ui red button",
            module: MODULES.Finance,
            form: DETAIL_FORM,
            editMode: params.data.chdId !== null && isNumber(params.data.chdId),
            authenticated: true,
            authType: AUTHORITY_TYPE.FORM,
            consider: AUTH_TYPES.DELETE,
            disabled: isDisabled(params),
          };
        },
      },
    ];
    if (containsAnyGridPermissions()) {
      configData.push({
        headerCheckboxSelection: true,
        checkboxSelection: containsAnyGridPermissions(),
        field: "",
        pinned: "left",
        minWidth: "50",
        width: "50",
      });
    }
    return configData;
  };

  const cellDoubleClickHandler = (params) => {
    if (isDisabled(params)) return;

    console.log("params", params);
    switch (params.colDef.headerName) {
      case "Currency": {
        setRowData(params.data);
        setExchangeRate({
          key: params.data.chdExcCurrency?.excId,
          text: params.data.chdExcCurrency?.curCode,
          value: JSON.stringify(params.data.chdExcCurrency),
        });
        openModal2();
        break;
      }
      default:
        break;
    }
  };

  console.log("row data", rowData);

  const onCurrencyHandler = (data) => {
    console.log("param data", data.value);
    const parsedData = data.value ? JSON.parse(data.value) : {};

    if (rowData.chdChargeType) {
      if (
        parseInt(rowData.chdChargeType) === 2 &&
        chargeHeader?.chhEvStatus === 3
      ) {
        setChargeHeader((prevState) => ({
          ...prevState,
          evModified: true,
        }));
      } else if (
        parseInt(rowData.chdChargeType) === 1 &&
        chargeHeader?.chhInvStatus === 3
      ) {
        setChargeHeader((prevState) => ({
          ...prevState,
          invModified: true,
        }));
      }
    }
    setGridData((prev) =>
      prev.map((item) => {
        if (item.id === rowData.id) {
          if (item.persisted) {
            return {
              ...item,
              chdExcCurrency: parsedData,
              chdExcId: parsedData?.excId,
              chdExcRate: parsedData?.excRate,
              chdTotal: item.chdQty * item.chdValue * parsedData?.excRate,
              mode: mode.EDIT,
            };
          } else {
            return {
              ...item,
              chdExcCurrency: parsedData,
              chdExcId: parsedData?.excId,
              chdExcRate: parsedData?.excRate,
              chdTotal: item.chdQty * item.chdValue * parsedData?.excRate,
            };
          }
        }
        return item;
      }),
    );

    setExchangeRate({});
    setRowData({});
    closeModal2();
  };

  const formatter = useMemo(
    () =>
      userCurrencyCode
        ? Intl.NumberFormat("en-US", {
            style: "currency",
            currency: userCurrencyCode,
          })
        : null,
    [userCurrencyCode],
  );

  console.log("Exchange rate", exchangeRate);
  console.log(
    !approveEditPermission &&
      chargeHeader.chhEvStatus === 3 &&
      chargeHeader.chhInvStatus === 3,
  );

  return (
    <>
      {isBlurred && (
        <div className="blur-overlay">
          <LoadingSpinner message={editMode ? "Updating..." : "Saving..."} />
        </div>
      )}

      <div className="drawer-content">
        <div className="ui top attached tabular menu">
          <div
            className={`item ${drawerTab === 1 ? "active" : ""}`}
            onClick={() => {
              setDrawerTab(1);
            }}
          >
            <span>
              <DollarSign
                size={15}
                style={{
                  marginRight: "5px",
                }}
              />
            </span>
            <label>Pick Charges</label>
          </div>
        </div>
        <div
          className="ui bottom attached active tab segment"
          style={{ display: drawerTab === 1 ? "block" : "none" }}
        >
          {isLoading ||
          templateDetailsLoading ||
          isJobInfoLoading ||
          isExistingJobChargesLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <InfoList content={JobSummary} title={"Job Summary"} />
              {suppNegoList?.length > 0 ? (
                <div
                  class="ui styled accordion"
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  <div
                    className={`title ${activeAccordion ? "active" : ""}`}
                    onClick={() => setActiveAccordion(!activeAccordion)}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <label>Supplier Negotiation</label>
                      <i class="dropdown icon"></i>
                    </div>
                  </div>
                  <div className={`content ${activeAccordion ? "active" : ""}`}>
                    <SuppNegoList
                      suppNegoDataSet={suppNegoList}
                      formatter={formatter}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="ui segment">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    onClick={handleAddRow}
                    disabled={
                      !approveEditPermission &&
                      chargeHeader.chhEvStatus === 3 &&
                      chargeHeader.chhInvStatus === 3
                    }
                    module={MODULES.Finance}
                    form={DETAIL_FORM}
                    authenticated={true}
                    editMode={editMode}
                    Icon={Plus}
                    label="Add"
                  />
                  <Button
                    onClick={openModal}
                    disabled={
                      !saveAsTemplatePermission ||
                      gridData.length === 0 ||
                      selectedRows.length === 0
                    }
                    editMode={editMode}
                    Icon={Save}
                    label="SAVE AS TEMPLATE"
                  />
                </div>

                <Grid
                  ref={gridRef}
                  searchable={false}
                  module={MODULES.Finance}
                  multiRowSelection={containsAnyGridPermissions()}
                  showDownloadButton={chargeDetailPermissions?.FORM?.DOWNLOAD}
                  downloadParam={""}
                  downloadAction="Charge Creation Excel Download"
                  downloadOnlySelected={true}
                  heading="Add Charges"
                  stopEditingWhenCellsLoseFocus={true}
                  onSelectionChanged={handleSelectionChanged}
                  onCellEditingStopped={cellEditorParams}
                  onCellDoubleClicked={cellDoubleClickHandler}
                  content={gridData}
                  fullRowEdit={false}
                  config={getConfig()}
                />

                <div className="ui divider"></div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {!editMode ? (
                    <Button
                      type="submit"
                      template="create"
                      isLoading={isSubmitLoading}
                      module={MODULES.Finance}
                      form={HEADER_FORM}
                      authenticated={true}
                      editMode={editMode}
                      onClick={(e) => {
                        addCharge(e);
                      }}
                      disabled={
                        !(gridData.length > 0 && selectedRows.length > 0)
                      }
                    />
                  ) : (
                    <Button
                      type="submit"
                      template="create"
                      create={false}
                      isLoading={isUpdateLoading}
                      module={MODULES.Finance}
                      form={HEADER_FORM}
                      authenticated={true}
                      editMode={editMode}
                      onClick={(e) => {
                        updateCharge(e);
                      }}
                      disabled={
                        !(
                          (gridData.length > 0 && selectedRows.length > 0) ||
                          deletedList.length > 0
                        )
                      }
                    />
                  )}
                  {editMode && (
                    <Button
                      label={
                        chargeHeader.chhEvStatus === 2 ? "Update EV" : "Gen EV"
                      }
                      onClick={() => {
                        console.log("CHARGEHEADER ->> ", chargeHeader);
                        if (chargeHeader.chhEvStatus === 2) {
                          handleOpenEvinvDrawer(2, chargeHeader.chhJobId, true);
                        } else {
                          handleOpenEvinvDrawer(
                            2,
                            chargeHeader.chhJobId,
                            false,
                          );
                        }
                      }}
                      disabled={
                        !genEvPermission ||
                        !(
                          chargeHeader.chhEvStatus === 3 ||
                          chargeHeader.chhEvStatus === 2
                        )
                      }
                    />
                  )}
                  {editMode && (
                    <Button
                      label={
                        chargeHeader.chhInvStatus === 2
                          ? "Update INV"
                          : "Gen INV"
                      }
                      onClick={() => {
                        if (chargeHeader.chhInvStatus === 2) {
                          handleOpenEvinvDrawer(1, chargeHeader.chhJobId, true);
                        } else {
                          handleOpenEvinvDrawer(
                            1,
                            chargeHeader.chhJobId,
                            false,
                          );
                        }
                      }}
                      disabled={
                        !genInvPermission ||
                        !(
                          chargeHeader.chhInvStatus === 3 ||
                          chargeHeader.chhInvStatus === 2
                        )
                      }
                    />
                  )}
                </div>
                <>
                  {editMode && (
                    <InfoList
                      title="User Information"
                      content={[
                        {
                          title: "Created By",
                          value: chargeHeader.createdBy
                            ? chargeHeader.createdBy
                            : "N/A",
                        },
                        {
                          title: "Created Date",
                          value: chargeHeader.createdDate
                            ? formatFromJsonDate(chargeHeader.createdDate)
                            : "N/A",
                        },
                        {
                          title: "Last Modified By",
                          value: chargeHeader.lastModifiedBy
                            ? chargeHeader.lastModifiedBy
                            : "N/A",
                        },
                        {
                          title: "Last Modified Date",
                          value: chargeHeader.lastModifiedDate
                            ? formatFromJsonDate(chargeHeader.lastModifiedDate)
                            : "N/A",
                        },
                      ]}
                      Icon={User}
                    />
                  )}
                </>
              </div>
            </>
          )}
        </div>
      </div>
      <Modal ref={modalRef} minHeight="50vh" minWidth="50vw">
        <form className="ui form segment">
          <div className="two fields">
            <Input
              type="text"
              label="Template Name"
              placeholder="Template Name"
              required={true}
              value={templateName}
              onChange={(e) => {
                setTemplateName(e.target.value);
              }}
              error={currentErrors.intTemplateName}
              resetError={() =>
                setCurrentErrors((prevState) => {
                  const { intTemplateName: _, ...rest } = prevState;
                  return rest;
                })
              }
            />
            <Dropdown
              label="Category"
              required={true}
              clearable
              placeholder="Select Category"
              options={customerSupplierOpt}
              value={category}
              onChange={(e, data) => setCategory(data.value)}
              error={currentErrors.intCategory}
              resetError={() =>
                setCurrentErrors((prevState) => {
                  const { intCategory: _, ...rest } = prevState;
                  return rest;
                })
              }
            />
          </div>

          <div className="field">
            <Input
              type="text"
              label="Description"
              placeholder="Description"
              value={templateDescription}
              onChange={(e) => {
                setTemplateDescription(e.target.value);
              }}
            />
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div className="field" style={{ width: "100%" }}>
              <Button
                type="submit"
                template="create"
                isLoading={savingTemplate}
                onClick={(e) => {
                  saveAsTemplate(e);
                }}
              />
            </div>
          </div>
        </form>
      </Modal>

      <Modal
        ref={modal2Ref}
        closeButton={false}
        minWidth={"50vw"}
        minHeight={"50vh"}
      >
        <div
          className="ui form segment"
          style={{ height: "50vh", margin: "20px" }}
        >
          <Dropdown
            label="Currency"
            clearable={false}
            search={true}
            placeholder="Select Currency"
            options={exchangeRates}
            value={JSON.stringify(rowData.chdExcCurrency)}
            onChange={(e, data) => setExchangeRate(data)}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "5px",
            paddingBottom: "5px",
            gap: "5px",
          }}
        >
          <Button Icon={X} label={"Cancel"} onClick={closeModal2} color="red" />
          <Button
            Icon={Check}
            label={"Ok"}
            onClick={() => onCurrencyHandler(exchangeRate)}
          />
        </div>
      </Modal>
    </>
  );
};

export default AddCharges;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
